import { BlockedUserCardWrapper } from './blocked-user-card-wrapper'
import { Skeleton, Stack, Cover } from 'design-system'

export const BlockedUserLoading = () => {
  return (
    <Cover fullSize className="px-4">
      <BlockedUserCardWrapper>
        <Stack gap={4}>
          <div className="flex justify-center">
            <Skeleton className="h-10 w-10 rounded-full" />
          </div>
          <Stack gap={3}>
            <Skeleton className="h-6" />
            <Skeleton className="h-40" />
            <Skeleton className="h-4" />
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-8" />
            <Skeleton className="h-10" />
            <Skeleton className="h-8" />
            <Skeleton className="h-4" />
            <Skeleton className="h-4" />
          </Stack>
          <div className="flex justify-center">
            <Skeleton className="h-8 w-44" />
          </div>
        </Stack>
      </BlockedUserCardWrapper>
    </Cover>
  )
}
